import { Input } from 'src/design/atoms/Input';
import { Stack } from 'src/design/atoms/Stack';
import { Title } from 'src/design/atoms/Title';
import React from 'react';
import { JobUserSelectV2 } from 'src/app/selectors/JobUserSelectV2';
import { RoleUserSelector } from './RoleUserSelector';
import type { WorkflowStepDto } from './EditDrawer';

export interface IEditDrawerApprovalTabProps {
  current: WorkflowStepDto;
  isTemplateEditor: boolean;
  onFieldChange: (field: string, value: any) => void;
}

/** @registry Approval tab of a workflow step's EditDrawer — approval roles and users. */
export const EditDrawerApprovalTab: React.FC<IEditDrawerApprovalTabProps> = ({
  current,
  isTemplateEditor,
  onFieldChange,
}) => {
  return (
    <Stack gap="lg">
      <Title order={3}>Approval Settings</Title>
      <Input.Wrapper
        label="Approval"
        description="Users with these roles can perform approval"
      >
        <RoleUserSelector
          onUserSelect={(val) =>
            onFieldChange(
              'excludedApprovalUsers',
              val.map((user) => ({
                jobUser: user,
                jobUserId: user.id,
              })),
            )
          }
          initialUsers={current.excludedApprovalUsers.map(
            (user) => user.jobUser,
          )}
          field={'approvalRoles'}
          placeholder="Select approval roles..."
          initialSelectedRoles={current.approvalRoles.map(
            (role) => role.organizationRole,
          )}
          selectedRoles={current.approvalRoles.map(
            (role) => role.organizationRole,
          )}
          selectDescription="Select users to EXCLUDE from approval roles"
          onFieldChange={(field, value) =>
            onFieldChange(
              field,
              value.map((role) => ({
                organizationRoleId: role.id,
                organizationRole: role,
              })),
            )
          }
        />
      </Input.Wrapper>

      <Input.Wrapper
        hidden={isTemplateEditor}
        label="Approval Users"
        description="Selected users will be able to approve regardless of roles"
      >
        <JobUserSelectV2
          hidden={isTemplateEditor}
          onChange={(value) =>
            onFieldChange(
              'approvalUsers',
              value.map((user) => ({
                jobUserId: user.id,
                jobUser: user,
              })),
            )
          }
          value={current.approvalUsers.map((user) => user.jobUser)}
          hideLabel
        />
      </Input.Wrapper>
    </Stack>
  );
};
